export default "__VITE_ASSET__CtZzVr_7__"